import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

function initTrustedMarquee() {
  const trustedMarqueeArr = document.querySelectorAll('.trusted-marquee');

  trustedMarqueeArr.forEach((trustedMarqueeEl, i) => {
    new CometMarquee(trustedMarqueeEl, {
      speed: 50,
      pauseOnHover: true,
      initialShift: window.innerWidth >= 1033,
      pauseOnInvisible: true,
      syncPause: false,
      repeatCount: 5,
      forceAnimation: window.innerWidth >= 1033,
      forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
      reverse: i % 2 === 1,
      fullWidth: window.innerWidth >= 1033,
    });
  });
}

if (document.fonts) {
  document.fonts.ready.then(initTrustedMarquee);
} else {
  window.addEventListener('load', initTrustedMarquee);
}
